import React, { Component } from 'react';
import { Card, CardTitle, CardText, CardImg, CardImgOverlay } from 'reactstrap';

export class HeroImage extends Component {
    static displayName = HeroImage.name;

    render() {
        return (
            <div>
                <Card inverse>
                    <CardImg width="100%" src="/images/Apparel_2017_02_gallery_1920x1080.jpg" alt="Apparel" />
                    <CardImgOverlay>
                        <CardTitle>Pacific Motosports</CardTitle>
                        <CardText></CardText>
                        <CardText>
                            <small className="text-muted"></small>
                        </CardText>
                    </CardImgOverlay>
                </Card>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/HeroImage/index.js